import api from './api';
import apiNoHeaders from './apiNoHeaders';
import idbService from './idbService';
import { createTipoDocumentoModel } from '../utils/tipoDocumentoUtils';

// idb store name
const storeName = 'tiposDocumento';

// Recurso SQL Api Syclus
const environment = process.env.NODE_ENV;
const configLocal = localStorage.getItem('configPedidos');
const host = configLocal ? JSON.parse(configLocal).host : '';
const apiRequest = environment === 'production' ? api : apiNoHeaders;
const baseURL = environment === 'production' ? `erp?url=${host}` : host;
const endpoint = 'tipodocumento';
// const sqlTipoDocumento = 8;

export const tipoDocumentoService = {
  getTiposDocumento,
  getTiposDocumentoAPI,
  getTipoDocumento,
  addTipoDocumento,
  addTiposDocumento,
  updateTipoDocumento,
  compareAndUpdateTiposDocumento
};

function getTiposDocumento() {
  // Fetch indexedDB Items
  // const itemsIndexedDB = await getIndexedDBTiposDocumento();
  // if (itemsIndexedDB.length) return itemsIndexedDB;
  // return getTiposDocumentoAPI();
  return getIndexedDBTiposDocumento();
}

async function getTiposDocumentoAPI() {
  const response = await apiRequest.post(`${baseURL}/${endpoint}`, {
    campos: [
      "id_tipo_documento",
      "tipo_documento"
    ],
    filtros: [
      {
        campo: "status",
        criterio: "igual",
        valor: "A"
      }
    ]
  }, {
    params: {
      Acao: 'lista'
    }
  });
  const tiposDocumentoApi = environment === 'production' ? response.data.result || [] : response.data || [];
  
  await compareAndUpdateTiposDocumento(tiposDocumentoApi);
  await removeInexistentes(tiposDocumentoApi);
  return tiposDocumentoApi;
}

function getIndexedDBTiposDocumento() {
  return idbService.getAll(storeName);
}

function getTipoDocumento(id) {
  return idbService.getById(storeName, id);
}

async function compareAndUpdateTiposDocumento(tiposDocumento) {
  if (tiposDocumento && tiposDocumento.length) {
    for (const tipoDocumento of tiposDocumento) {
      const savedTipoDocumento = await getTipoDocumento(tipoDocumento.id_tipo_documento);
  
      if (!savedTipoDocumento) {
        tipoDocumento.versao_imp = 1;
        await addTipoDocumento(tipoDocumento);
      } else {
        tipoDocumento.versao_imp = savedTipoDocumento.versao_imp ? savedTipoDocumento.versao_imp + 1 : 1;
        await updateTipoDocumento(tipoDocumento);
      }
    }
  } else {
    // Limpa os registros do store tipoDocumentos
    await idbService.clearStore(storeName);
  }
}

async function removeInexistentes(tiposDocumentoApi) {
  if (tiposDocumentoApi && tiposDocumentoApi.length) {
    const idsTiposDocumentoApi = tiposDocumentoApi.map(tipoDocumentoApi => tipoDocumentoApi.id_tipo_documento);
    const tiposDocumentoLocal = await idbService.getAll(storeName);
    const tiposDocumentoInexistentes = tiposDocumentoLocal.filter(tipoDocumentoLocal => !idsTiposDocumentoApi.includes(tipoDocumentoLocal.id_tipo_documento));
    if (tiposDocumentoInexistentes && tiposDocumentoInexistentes.length) {
      for (const tipoDocumento of tiposDocumentoInexistentes) {
        await idbService.deleteFromStore(storeName, tipoDocumento.id_tipo_documento);
      }
    }
  } else {
    return;
  }
}

async function addTipoDocumento(tipoDocumento) {
  const parsedTipoDocumento = createTipoDocumentoModel(tipoDocumento);
  return idbService.addToStore(storeName, parsedTipoDocumento);
}

async function addTiposDocumento(tiposDocumento = []) {
  const parsedTiposDocumento = tiposDocumento.map(tipoDocumento => createTipoDocumentoModel(tipoDocumento));
  return idbService.addMultipleToStore(storeName, parsedTiposDocumento);
}

async function updateTipoDocumento(tipoDocumento) {
  const parsedTipoDocumento = createTipoDocumentoModel(tipoDocumento);
  await idbService.updateItem(storeName, parsedTipoDocumento);
}